import axios from 'axios';
import { newApiBaseUrl } from '../../axiosInstance';

export const GetPriceList = async (gtin) => {
    try {
        const params = {
            gtin,
            includeHamazon: false
        };

        const response = await axios.get(`${newApiBaseUrl}/productprices`, {
            params,
            headers: {
                "Content-Type": "application/json",
                'Authorization': `bearer ${localStorage.jwtToken}`,
                "X-Tenant": "hamazon",
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching price list:", error);
        throw error;
    }
};
